// extracted by mini-css-extract-plugin
export default {"archiveButton":"ArchiveButton_archiveButton__BZ6sK"};